import { render, staticRenderFns } from "./Bitacora.vue?vue&type=template&id=1ff33362"
import script from "./Bitacora.vue?vue&type=script&lang=js"
export * from "./Bitacora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports